'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.onError = onError;
exports.onPlay = onPlay;
exports.onPositionChanged = onPositionChanged;

var _baseState = require('./baseState');

var _baseState2 = _interopRequireDefault(_baseState);

var _tuner = require('../tuner');

var _tuner2 = _interopRequireDefault(_tuner);

var _listenTime = require('../loggers/listenTime');

var _listenTime2 = _interopRequireDefault(_listenTime);

var _debugger = require('../debugger');

var _debugger2 = _interopRequireDefault(_debugger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onError(e) {
  _debugger2.default.log('error while attempting to play', e);
  _tuner2.default.changeState(_tuner2.default.states.connecting);
}

function onPlay() {
  _listenTime2.default.setReportStartTime();
  _tuner2.default.changeState(_tuner2.default.states.playing);
}

function onPositionChanged(data) {
  _tuner2.default.trigger(_tuner2.default.events.positionChanged, data);
}

var state = {
  name: 'paused',
  enter: function enter() {
    _tuner2.default.trigger(_tuner2.default.events.paused);
    _tuner2.default.streamPlayer.on(_tuner2.default.streamPlayer.events.positionChanged, onPositionChanged);
  },
  play: function play() {
    // if you are changing streams, you will no longer be in
    // paused and thus this will not fire. Goes to loading, etc first
    _tuner2.default.streamPlayer.play().then(onPlay).catch(onError);
  },
  seek: function seek(position) {
    _tuner2.default.streamPlayer.seek(position);
  },
  load: function load(promise) {
    _listenTime2.default.resetOffsets();

    _tuner2.default.changeState(_tuner2.default.states.loading, promise);
  },
  exit: function exit() {
    _tuner2.default.streamPlayer.remove(_tuner2.default.streamPlayer.events.positionChanged, onPositionChanged);
  }
};

exports.default = (0, _extends3.default)({}, _baseState2.default, state);
//# sourceMappingURL=paused.js.map